// extracted by mini-css-extract-plugin
var _1 = "TabFrame_group__92688";
var _2 = "TabFrame_items__60f34";
var _3 = "TabFrame_root__0c660";
export { _1 as "group", _2 as "items", _3 as "root" }
